import { axios } from "..";
import type { NetworkingMapResponse } from "../pages/EventsPage/networkingMap/networkingMapTypes";

export type EventNetworkingMapParams = {
  categories?: string[];
  maxConnections?: number;
};

export const getEventNetworkingMap = async (
  eventId: string,
  { categories, maxConnections }: EventNetworkingMapParams = {},
): Promise<NetworkingMapResponse | null> => {
  try {
    const params = new URLSearchParams();
    if (categories?.length) {
      params.append("categories", categories.join(","));
    }
    if (maxConnections != null) {
      params.append("maxConnections", String(maxConnections));
    }

    const query = params.toString();
    const response = await axios.Get(
      `./event-networking-map/${eventId}${query ? `?${query}` : ""}`,
    );

    const data = response.data as NetworkingMapResponse | undefined;
    if (!data || !Array.isArray(data.nodes) || !Array.isArray(data.edges)) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
};
